import { useAssetTransfers } from "@/hooks/useAssets";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { LoadingSpinnerWithText } from "@/components/ui/loading-spinner";
import { Calendar, ArrowRightLeft, CheckCircle, XCircle, Clock } from "lucide-react";
import { format } from "date-fns";
import { ar } from "date-fns/locale";

export function AssetTransfersList() {
  const { data: transfers = [], isLoading } = useAssetTransfers();

  const statusMap: Record<string, { label: string; color: string; icon: JSX.Element } > = {
    pending: { label: "قيد الانتظار", color: "bg-yellow-100 text-yellow-800 border-yellow-300", icon: <Clock className="w-3 h-3" /> },
    approved: { label: "معتمد", color: "bg-green-100 text-green-800 border-green-300", icon: <CheckCircle className="w-3 h-3" /> },
    rejected: { label: "مرفوض", color: "bg-red-100 text-red-800 border-red-300", icon: <XCircle className="w-3 h-3" /> },
    completed: { label: "منجز", color: "bg-blue-100 text-blue-800 border-blue-300", icon: <CheckCircle className="w-3 h-3" /> },
  };

  if (isLoading) {
    return (
      <div className="p-4">
        <LoadingSpinnerWithText text="جاري تحميل عمليات النقل..." />
      </div>
    );
  }

  if (!transfers.length) {
    return (
      <Card>
        <CardContent className="py-10 text-center text-muted-foreground">
          لا توجد عمليات نقل
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">سجل عمليات نقل العهد</CardTitle>
      </CardHeader>
      <CardContent className="overflow-x-auto">
        <table className="w-full text-sm" dir="rtl">
          <thead>
            <tr className="text-muted-foreground text-xs">
              <th className="text-right py-2 font-medium">التاريخ</th>
              <th className="text-right py-2 font-medium">العهدة</th>
              <th className="text-right py-2 font-medium">من</th>
              <th className="text-right py-2 font-medium">إلى</th>
              <th className="text-right py-2 font-medium">الحالة</th>
            </tr>
          </thead>
          <tbody>
            {transfers.map((t: any) => {
              const status = statusMap[t.status] || statusMap.pending;
              return (
                <tr key={t.id} className="border-t">
                  <td className="py-2 whitespace-nowrap">
                    <div className="flex items-center gap-2 text-muted-foreground">
                      <Calendar className="w-3 h-3" />
                      <span>{t.transfer_date ? format(new Date(t.transfer_date), "dd MMM yyyy", { locale: ar }) : "-"}</span>
                    </div>
                  </td>
                  <td className="py-2">
                    <div className="font-medium">{t.asset?.asset_name || "-"}</div>
                    <div className="text-xs text-muted-foreground">{t.asset?.asset_code}</div>
                  </td>
                  <td className="py-2">{t.from_employee?.name || "-"}</td>
                  <td className="py-2">{t.to_employee?.name || "-"}</td>
                  <td className="py-2">
                    <Badge variant="outline" className={`text-xs border ${status.color} inline-flex items-center gap-1`}>
                      {status.icon}
                      {status.label}
                    </Badge>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </CardContent>
    </Card>
  );
}
